<style lang="scss" scoped>
    .border-bottom{
        border-bottom: 1px dashed #8cb9e8;
    }
</style>
<template>
    <div>
        <!-- <Alert type="error" class="color-error margin-left-15">
            考虑到安全性，此处不展示此前填入的参数信息。留空即表示不更改原参数值。若有参数变更，请重新填写。
        </Alert> -->
        <!-- amazon -->
        <div>
            <vForm :label-width="160" ref="amazonform" class="margin-15 clearfix" :key="keyindex">
                <vCol span="24">
					<vFormItem label="区域" :rules="required" prop="areaCode">
                        <!-- {{disabledFormdata.areaCode}} -->
                        <vCheckbox v-for="(item,index) in alist" :key="index" :trueValue="item.trueValue" v-model="formData.areaCode" :disabled="disabledFormdata.areaCode.indexOf(item.trueValue)>-1">{{item.label}}</vCheckbox>
					</vFormItem>
				</vCol>
                <!-- {{formData.areaCode}} -->
                <div  v-for="(val) in formData.areaCode" :key="val" class="border-bottom">
                    <div v-if="readFun(defaultFormdata[val].countryCode,defaultCountry[val].countryCode)">
                        <vFormItem label="Country" :rules="required" prop="countryCode">
                            <div v-for="(json,index) in getCountryList(val)" :key="index">
                                <div>{{json.title}} {{json.code}} <span v-if="formData1[val].isMain==index" class="margin-left-10 color-error">{{$t('erp.channelbase.default_main_account', { defaultValue: '默认为主账号' })}}</span></div>
                            </div>
                        </vFormItem>
                        <vFormItem label="Seller ID" >
                            <div class="width-30per">{{formData1[val].sellerId||'******'}}</div>
                        </vFormItem>
                        <!-- <vFormItem label="mwsAuthToken" >
                            <div class="width-30per">{{formData1[val].mwsAuthToken}}</div>
                        </vFormItem>
                        <vFormItem label="merchantToken" >
                            <div class="width-30per">{{formData1[val].merchantToken}}</div>
                        </vFormItem> -->
                        <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                            <!-- <span v-for="(item,index) in productList" :key="index" class="margin-right-10">{{item.title}}</span> -->
                            <vCheckbox v-for="(item,index) in productList" :disabled="true" :trueValue="item.value" :key="index" v-model="formData1[val].isProduct" >{{item.title}}</vCheckbox>
                        </vFormItem>
                    </div>
                    <div v-else>
                        <vFormItem label="Country" :rules="required" prop="countryCode">
                            <div v-for="(json,index) in getCountryList(val)" :key="index">
                                <vCheckbox v-model="formData1[val].countryCode" :trueValue="json.value" :disabled="disabledFormdata[val].countryCode.indexOf(json.value)>-1">{{json.title}}{{json.code}}</vCheckbox>
                                <vRadio :trueValue="index" :strict="false" :label="$t('erp.channelbase.default_main_account', { defaultValue: '默认为主账号' })" v-model="formData1[val].isMain"></vRadio>
                                <span v-if="formData1[val].isMain==index" class="color-error">{{$t('erp.channelbase.choose_one_main_account', { defaultValue: '只能选一个作为主账号，其他账号作为子账号。否则会多账号重复抓取数据' })}}</span>
                            </div>
                        </vFormItem>
                        <vFormItem label="Seller ID" :rules="required" prop="sellerId">
                            <vInput class="width-30per" v-model="formData1[val].sellerId"></vInput>
                        </vFormItem>
                        <!-- <vFormItem label="mwsAuthToken" >
                            <vInput class="width-30per" v-model="formData1[val].mwsAuthToken"></vInput>
                        </vFormItem>
                        <vFormItem label="merchantToken" >
                            <vInput class="width-30per" v-model="formData1[val].merchantToken"></vInput>
                        </vFormItem> -->
                        <vFormItem :label="$t('erp.channelbase.start_data_type', { defaultValue: '开启同步的数据类型' })" >
                            <vCheckbox v-for="(item,index) in productList" :trueValue="item.value" :key="index" v-model="formData1[val].isProduct" >{{item.title}}</vCheckbox>
                        </vFormItem>
                    </div>
                </div>
            </vForm>
        </div>
    </div>
</template>

<script>
export default {
    props:['parentCountries'],
    data(){
        return {
            formData:{
                areaCode:[],
                countryCode:[],
            },
            alist:[
				{label:this.$t('erp.channelbase.north_america', { defaultValue: '北美' }),trueValue:'North America'},
				{label:this.$t('erp.channelbase.europe', { defaultValue: '欧洲' }),trueValue:'Northwest Europe'},
				{label:this.$t('erp.channelbase.asia', { defaultValue: '亚洲' }),trueValue:'Asia'},
            ],
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
            formData1:{
                'North America':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },
                'Northwest Europe':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },
                'Asia':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                }
            },
            productList:[
                {title:this.$t('erp.channelbase.product', { defaultValue: "产品" }),value:"product"},
                {title:this.$t('erp.channelbase.order', { defaultValue: "订单" }),value:"order"},
                {title:this.$t('ucadm.notice.report', { defaultValue: "报表" }),value:"report"},
                {title:this.$t('erp.channelbase.caiwu', { defaultValue: "财务" }),value:"finance"},
                {title:this.$t('erp.channelbase.inbound', { defaultValue: "进库" }),value:"inbound"},
                {title:this.$t('erp.channelbase.outbound', { defaultValue: "出库" }),value:"outbound"},
                {title:this.$t('fbb.adjustment.list_inventory', { defaultValue: "库存" }),value:"stock"},
            ],
            allformData:{},
            disabledFormdata:{
                areaCode:[],
                'North America':{
                    countryCode:[],
                },
                'Northwest Europe':{
                    countryCode:[],
                },
                'Asia':{
                    countryCode:[],
                }
            },
            defaultCountry:{
                'North America':{
                    countryCode:['CA','MX','US'],
                },
                'Northwest Europe':{
                    countryCode:['DE','ES','IT','FR','GB','NL','SE','BE','AE','PL','TR'],
                },
                'Asia':{
                    countryCode:['AU','JP'],
                }
            },
            defaultFormdata:{
                'North America':{
                    countryCode:[],
                },
                'Northwest Europe':{
                    countryCode:[],
                },
                'Asia':{
                    countryCode:[],
                }
            },
            keyindex:1,
        }
    },
    watch:{
        parentCountries:{
            immediate:true,
            deep:true,
            handler(val){
                // console.log(val)
                this.allformData=val||{};
                this.keyindex += 1
                this.handledata(val)
            }
        }
    },
    computed:{

    },
    created(){
        // this.handle()
    },
    methods:{
        readFun(formarr,defaultarr){
            let bool;
            let arr1 = formarr.concat()
            let arr2 = defaultarr.concat()
            let a = arr1.sort().toString()
            let b = arr2.sort().toString()
            // console.log(a,'4444444')
            // console.log(b,'6666')
            // console.log(a == b)
            if(a == b){ bool = true }else{ bool=false }
            return bool
        },
        resetdata(){
            this.formData = {
                areaCode:[],
                countryCode:[],
            };
            this.formData1 = {
                'North America':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },
                'Northwest Europe':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                },
                'Asia':{
                    sellerId:"",
                    mwsAuthToken:"",
                    merchantToken:"",
                    countryCode:[],
                    isMain:-1,
                    isProduct:[],
                }
            };
            this.disabledFormdata = {
                areaCode:[],
                'North America':{
                    countryCode:[],
                },
                'Northwest Europe':{
                    countryCode:[],
                },
                'Asia':{
                    countryCode:[],
                }
            };
            this.defaultFormdata = {
                'North America':{
                    countryCode:[],
                },
                'Northwest Europe':{
                    countryCode:[],
                },
                'Asia':{
                    countryCode:[],
                }
            }
        },
        handledata(val){
            console.log(val,'787789746837')
            if(!val.channelCategoryId) return;
            let arr = []

            // 各个初始值的赋值
            this.resetdata()
            this.allformData.areaCountryRequest.map((item,index)=>{

                this.formData.areaCode.push(item.areaCode)
                this.disabledFormdata.areaCode.push(item.areaCode)

                item.countryRequest.map(json=>{
                    this.formData1[item.areaCode].countryCode.push(json.countryCode)

                    this.defaultFormdata[item.areaCode].countryCode.push(json.countryCode)

                    this.disabledFormdata[item.areaCode].countryCode.push(json.countryCode)

                    this.getCountryList(item.areaCode).map((country,conIndex)=>{
                        if(country.value==json.countryCode && json.isMain==1){
                            this.formData1[item.areaCode].isMain = conIndex
                        }
                    })
                })
                this.formData1[item.areaCode].isProduct = []
                for(let key in item.countryRequest[0].connectStr.new_flag){
                    if(item.countryRequest[0].connectStr.new_flag[key] == 'Y'){
                        this.formData1[item.areaCode].isProduct.push(key)
                    }
                }
                // this.formData1[item.areaCode].sellerId = item.countryRequest[0].connectStr.sellerId
                // this.formData1[item.areaCode].merchantToken = item.countryRequest[0].connectStr.merchantToken
                // this.formData1[item.areaCode].mwsAuthToken = item.countryRequest[0].connectStr.mwsAuthToken
                this.formData1[item.areaCode].sellerId = ''
                this.formData1[item.areaCode].merchantToken = ''
                this.formData1[item.areaCode].mwsAuthToken = ''
            })
            // console.log(this.disabledFormdata)
            // console.log(this.formData1)
        },
        getCountryList(val){
            let data;
            switch(val){
                case 'North America':
                    data = [
                        {value:'CA',title:"Canada",code:"(amazon.ca)"},
                        {value:'MX',title:"Mexico",code:"(amazon.mx)"},
                        {value:'US',title:"UNITED STATES",code:"(amazon.com)"},
                    ]
                    return data
                break;
                case 'Northwest Europe':
                    data = [
                        {value:'DE',title:"Germany",code:"(amazon.de)"},
                        {value:'ES',title:"Spain",code:"(amazon.es)"},
                        {value:'IT',title:"Italy",code:"(amazon.it)"},
                        {value:'FR',title:"FRANCE",code:"(amazon.fr)"},
                        {value:'GB',title:"UNITED KINGDOM",code:"(amazon.uk)"},
                        {value:'AE',title:"The United Arab Emirates",code:"(amazon.ae)"},
                        {value:'NL',title:"The Netherlands",code:"(amazon.nl)"},
                        {value:'SE',title:"Sweden",code:"(amazon.se)"},
                        {value:'PL',title:"Poland",code:"(amazon.pl)"},
                        {value:'BE',title:"Belgium",code:"(amazon.bel)"},
                        {value:'TR',title:"Turkey",code:"(amazon.com.tr)"},
                    ]
                    return data
                break;
                case 'Asia':
                    data = [
                        {value:'AU',title:"AUSTRALIA ",code:"(amazon.au)"},
                        {value:'JP',title:"JAPAN",code:"(amazon.jp)"},
                    ]
                    return data
                break;
            }
        },
        async validate(){
                // console.log(123123)
            const bool1 = await this.$refs['amazonform'].validate();
            // console.log(bool1)
            if (!bool1) {
                this.$VMessage.warning(this.$t('global.common.fill_required', { defaultValue: "请填写必填项" }));
            }
            return bool1;
		},
    },
}
</script>
